import './all_events.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
export default function AllEvents() {
  const navigate = useNavigate();
  return (
    <div id="events-section">
      <h1 id="events-title">Events</h1>
      <div id="row-1">
        <div id="card">
          <div id="event-left-side">
            <p id="overlay-text">
              IYNS Research Foundation at Second Joint IAEA-ICTP Workshop on Open-Source Nuclear
              Codes for Reactor Analysis, Trieste, Italy
            </p>
          </div>
          {/* Right side: Content */}
          <div id="event-right-side">
            <p id="event-title">
              IYNS Research Foundation at Second Joint IAEA-ICTP Workshop on Open-Source Nuclear
              Codes for Reactor Analysis, Trieste, Italy
            </p>
            <p id="event-card-text">
              India's first micro nuclear reactor, SUK-M, which is being designed by IYNS Research
              Foundation, was proudly presented by IYNS Research Foundation Vice-President Dr.
              Samyak Munot at the prestigious Second Joint IAEA-ICTP Workshop
            </p>
            <button
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/events/micro-nuclear-reactor')}
            >
              <FontAwesomeIcon
                icon={faArrowAltCircleRight}
                style={{ color: 'white', fontSize: '2.25rem' }}
              />
            </button>
          </div>
        </div>
        <div id="second-event">
          <p id="second-event-title" style={{ color: '#000000' }}>
            IYNS Research Foundation at Gastech, Milan Italy
          </p>
          <div class="button-space">
            <button
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/events/nuclear-codes-for-reactor-analysis')}
            >
              <FontAwesomeIcon
                icon={faArrowAltCircleRight}
                style={{ color: 'black', fontSize: '2.25rem' }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
